import PropTypes from 'prop-types'
import RefType from '@shapr/react-shared/types/Ref'

export const ObjectType = {
  inputValue: PropTypes.string.isRequired,
  setInputValue: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  inputRef: RefType,
  isWithMultipleSelection: PropTypes.bool.isRequired,
  selectedValues: PropTypes.arrayOf(PropTypes.string.isRequired),
  setSelectedsValue: PropTypes.func,
  onSelectChange: PropTypes.func,
  isWithSuggestions: PropTypes.bool.isRequired,
  suggestionValues: PropTypes.arrayOf(PropTypes.string.isRequired),
  setSuggestionValues: PropTypes.func,
  suggestionIsOpen: PropTypes.bool,
  setSuggestionIsOpen: PropTypes.func,
  isWithAddButton: PropTypes.bool.isRequired,
}

export default PropTypes.shape(ObjectType)
